import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import {
    Spin,
    Table,
    Input,
    Button,
    Dropdown,
    Menu,
    Popconfirm, Drawer, Select, InputNumber
} from "antd";
import { v4 as uuidv4 } from 'uuid';
import {
    createQuotation,
    deleteQuotationMethod,
    getAllQuotationMethod,
    getAllJobTypeMethod,
    getQuotationNumMethod,
    approveQuotationMethod,
} from "../../service/ApiServices";
import Swal from "sweetalert2";
import {
    FaFilePdf,
    FaTrash,
    FaEdit,
    FaEye,
    FaEllipsisV,
    FaCheck,
} from "react-icons/fa";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { DatePicker } from "antd";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


const { RangePicker } = DatePicker;
import dayjs from "dayjs";


const QuotationList = () => {
    const startOfCurrentMonth = dayjs().subtract(2, 'year').startOf('month');
    const endOfCurrentMonth = dayjs().endOf('month');

    const [selectedRange, setSelectedRange] = useState([
        startOfCurrentMonth,
        endOfCurrentMonth,
    ]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [jobDate, setJobDate] = useState("");
    const [quoteDate, setQuoteDate] = useState("");
   
    const [customerName, setCustomerName] = useState("");
    const [customerPhone, setCustomerPhone] = useState("");
   

    const [loading, setLoading] = useState(false);
    
    const [loading3, setLoading3] = useState(false);
    const [loading4, setLoading4] = useState(false);
    const [jobTypeOptions, setJobTypeOptions] = useState([]);
    const [tableItems, setTableItems] = useState([{
        label: "",
        qty: 1,
        price: "",
        totalPrice: "",
        itemId: null,
        rowId: uuidv4()
    }]);
    const [comment, setComment] = useState("")
    const [discount, setDiscount] = useState(0);
    const [discountType, setDiscountType] = useState("fixed");
    const [quotationNum, setQuotationNum] = useState(0);
    const [isQuotationCreated, setIsQuotationCreated] = useState(false);
    const [search, setSearch] = useState("");
    const [selectedQuotation, setSelectedQuotation] = useState(null);
    const [selectedQuotationForEdit, setSelectedQuotationForEdit] =
        useState(null);


    const [quotationData, setQuotationData] = useState({
        data: [],
        page: 1,
        limit: 10,
        total: 0,
    });
    loading

     const storedUserData = localStorage.getItem("user");
  const userData = JSON.parse(storedUserData);
  const roleName = userData?.data.role.roleName;
  const userName = userData?.data.name
    const handleCancel = () => {
        setIsModalOpen(false);
        setSelectedQuotation(null);
        setSelectedQuotationForEdit(null);
        handleReset();
    };
   

    const handleAdd = () => {
        // Check if there's already an empty row
        const hasEmptyRow = tableItems.some(item => !item.jobTypeId);
        
        if (hasEmptyRow) {
            Swal.fire({
                title: "Warning!",
                text: "Please fill out the current empty row before adding a new one",
                icon: "warning",
            });
            return;
        }
        
        const newData = {
            label: "",
            qty: 1,
            price: "",
            totalPrice: "",
            itemId: null,
            rowId: uuidv4()
        };
        setTableItems([...tableItems, newData]);
    };
    jobTypeOptions
    const showModal = () => {
        setIsModalOpen(true);
    };

    const deleteItem = (rowId) => {
        setTableItems(tableItems.filter((item) => item.rowId !== rowId));
    };

    const getRateQuotationNum = async () => {
        const data3 = await getQuotationNumMethod();
        setQuotationNum(data3.quotationNumber);
    };

    const columns = [
        {
            title: "ITEM DETAIL",
            dataIndex: "label",
            key: "label",
            render: (text, record, index) => <Select
                showSearch
                placeholder="Select Item"
                filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: 200 }}
                onChange={(value, option) => setItemDetails(record, option, index)}
                value={record.jobTypeId}
            >
                {jobTypeOptions.map(jobType => (
                    <Select.Option key={jobType.value} value={jobType.value} jobType={jobType}>
                        {jobType.label}
                    </Select.Option>
                ))}
            </Select>
        },
        {
            title: "QUANTITY",
            dataIndex: "qty",
            key: "qty",
            width: 20,
            render: (_, record, index) => <InputNumber min={1}  value={record.qty}  defaultValue={1} onChange={(value) => handleQtyChange(value, record, index)} />
        },
        {
            title: "RATE",
            dataIndex: "price",
            key: "price",
            render: (_, record) => <InputNumber value={record.price} addonBefore="LKR" onChange={(value) => setItemDetails(record, value)}
            />
        },
        {
            title: "AMOUNT",
            dataIndex: "totalPrice",
            key: "totalPrice",
            render: (text, record) => record.qty * record.price,
        },
        {
            render: (_, record) => (

                <Button
                    type="link"
                    className="text-danger text-right"
                    disabled={selectedQuotation}
                    onClick={() => deleteItem(record.rowId)}
                >
                    <i data-feather="trash-2" className="feather-delete"></i>
                </Button>
            ),
        },
    ];

    const quotationColumns = [
        {
            title: "Quote Date",
            dataIndex: "quote_date",
            key: "quote_date",
            render: (quote_date) => quote_date ? new Date(quote_date).toLocaleDateString() : "N/A",
             defaultSortOrder: 'descend',
            sorter: (a, b) => new Date(a.quote_date) - new Date(b.quote_date),
        },
        {
            title: "Quotation Number",
            dataIndex: "quotation_number",
            key: "quotation_number",
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const numA = parseInt(a.quotation_number);
                const numB = parseInt(b.quotation_number);
                return numA - numB;
            },
        },
        {
            title: "Customer Name",
            dataIndex: "customer",
            key: "customer",
        },
        {
            title: "Amount",
            dataIndex: "total_after_discount",
            key: "total_after_discount",
            render: (text) => "LKR " + new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(text),
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => {
                if (status === "pending") {
                    return <span className="badge bg-warning">Pending</span>;
                } else if(status === "cancelled") {
                    return <span className="badge bg-danger">Cancelled</span>;
                }else{
                   return <span className="badge bg-success">Approved</span>; 
                }
            },
        },
        {
            title: "Action",
            key: "action",
            render: (text, record) => (
                <Dropdown
                    overlay={
                        <Menu>

                            <Menu.Item key="2" onClick={() => downloadPDF(record)}>
                                <FaFilePdf style={{ marginRight: 8 }} />
                                Download PDF
                            </Menu.Item>
                            <Menu.Item
                                key="3"
                                onClick={() => {
                                    setSelectedQuotation(record);
                                    showModal();
                                }}
                            >
                                <FaEye style={{ marginRight: 8 }} />
                                View Quotation
                            </Menu.Item>
                            {record.status === "pending" && (
                                <Menu.Item
                                    key="4"
                                    onClick={() => {
                                        setSelectedQuotationForEdit(record);
                                        showModal();
                                    }}
                                >
                                    <FaEdit style={{ marginRight: 8 }} />
                                    Edit Quotation {record.status}
                                </Menu.Item>
                            )}
                            {roleName ==='Admin' &&(
                            <Menu.Item key="5">
                                <Popconfirm
                                    title="Delete the task"
                                    description="Are you sure to delete this task?"
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={() => {
                                        deleteQuotationMethod({
                                            quotationId: record._id,
                                            showSuccess,
                                            setIsItemDeleted: setIsQuotationCreated,
                                        });
                                    }}
                                >
                                    <FaTrash style={{ marginRight: 8 }} />
                                    Delete Quotation
                                </Popconfirm>
                            </Menu.Item>
                            )}
                           {record.status === "pending" && (
                             <Menu.Item key="6">
                                <Popconfirm
                                    title="Approve the task"
                                    description="Are you sure to Approve this task?"
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={() => {
                                        approveQuotationMethod({
                                            quotationId: record._id,
                                            showSuccess,
                                            setIsItemApproved: setIsQuotationCreated,
                                        });
                                    }}
                                >
                                    <FaCheck style={{ marginRight: 8 }} />
                                    Approve Quotation
                                </Popconfirm>
                            </Menu.Item>
                           )}
                        </Menu>
                    }
                    trigger={["click"]}
                >
                    <Button type="text" icon={<FaEllipsisV />} />
                </Dropdown>
            ),
        },
    ];



    const calculateSubtotal = () => {
        return tableItems.reduce((acc, item) => acc + item.price * item.qty, 0);
    };

    const calculateTotalAfterDiscount = (subtotal) => {
        if (discountType === "fixed") {
            return subtotal - discount;
        } else if (discountType === "percentage") {
            return subtotal - subtotal * (discount / 100);
        }
        return subtotal;
    };



    const handleReset = () => {
        setTableItems([{
            label: "",
            qty: 1,
            price: "",
            totalPrice: "",
            itemId: null,
            rowId: uuidv4()
        }]);
        setJobDate("");
        setCustomerName("");
        setCustomerPhone("");
        setQuoteDate("")
        setDiscount(0);
        setDiscountType("fixed");
        setComment("")
    };

    const getBase64FromUrl = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    function formatNumber(number) {
        return number.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }

    const downloadPDF = async (quotationData) => {
        if (!quotationData) {
            Swal.fire({
                title: "Error!",
                text: "No quotation data selected for PDF export",
                icon: "error",
            });
            return;
        }
        
        try {
            const doc = new jsPDF("p", "mm", "a4");
            const pageWidth = doc.internal.pageSize.getWidth();
            
            try {
                const logoUrl = "assets/img/logo/logo.jpeg";
                const logoBase64 = await getBase64FromUrl(logoUrl);
                doc.addImage(logoBase64, "PNG", 14, 10, 50, 50);
            } catch (error) {
                console.error("Error loading logo:", error);
                // Continue without logo
            }

            // Company details x,y
            doc.setFontSize(20);
            doc.text("Quotation", 155, 14);
            doc.setFontSize(16);
            doc.text("The Suit", 155, 20);
            doc.setFontSize(10);
            doc.text("335, Colombo Road", 155, 26);
            doc.text("Negombo, Gampaha 11500", 155, 32);
            doc.text("Sri Lanka", 155, 38);
            doc.text("Phone: 0314355515", 155, 44);
            doc.text("Mobile: 0774055515", 155, 50);

            doc.setDrawColor(182, 182, 181);
            doc.line(0, 65, pageWidth, 65);
            
            // Quotation details
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            doc.text(`Quotation Number: ${quotationData.quotation_number}`, 155, 70);
            doc.text(
                `Quotation Date: ${new Date(
                    quotationData.quote_date || quotationData.createdAt
                ).toLocaleDateString()}`,
                155,
                76
            );
            doc.text(
                `Due Date: ${new Date(quotationData.due_date || new Date()).toLocaleDateString()}`,
                155,
                82
            );

            // Customer details
            doc.setTextColor(182, 182, 181);
            doc.setFontSize(12);
            doc.text("BILL TO", 14, 70);
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(9);
            
            if (quotationData) {
                doc.text(quotationData.customer || "N/A", 14, 76);
                doc.text(quotationData.phoneNumber || "N/A", 14, 82);
            }

            // Items table
            if (quotationData.items && quotationData.items.length > 0) {
                const items = quotationData.items.map((item) => [
                    item.itemDetails?.type || "N/A",
                    item.quantity || 0,
                    "Rs " + formatNumber(item.itemDetails?.price || 0),
                    "Rs " + formatNumber((item.quantity || 0) * (item.itemDetails?.price || 0)),
                ]);

                doc.autoTable({
                    startY: 100,
                    head: [["Items", "Quantity", "Price", "Amount"]],
                    body: items,
                    theme: "grid",
                    styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
                    headStyles: { fillColor: [74, 74, 73], textColor: [255, 255, 255] },
                    footStyles: { fillColor: [74, 74, 73], textColor: [255, 255, 255] },
                    columnStyles: {
                        0: { cellWidth: 70 },
                        1: { cellWidth: 30 },
                        2: { cellWidth: 40 },
                        3: { cellWidth: 40 },
                    },
                });
            } else {
                doc.text("No items found", 14, 100);
            }

            // Total section
            const finalY = doc.previousAutoTable?.finalY + 10 || 120;
            doc.setFont("helvetica", "normal");
            doc.text("Subtotal: ", 130, finalY);
            doc.text(`Rs ${formatNumber(quotationData.total || 0)}`, 170, finalY);
            doc.setDrawColor(182, 182, 181);
            doc.line(100, finalY + 2, 190, finalY + 2);
            doc.text("Discount: ", 130, finalY + 20);
            
            if (quotationData.discount) {
                doc.text(
                    `${quotationData.discount.amount || 0} (${quotationData.discount.type === "fixed" ? "LKR" : "%"})`,
                    170,
                    finalY + 20
                );
            }
            
            doc.text("Total After Discount: ", 130, finalY + 30);
            doc.text(
                `Rs ${formatNumber(quotationData.total_after_discount || 0)}`,
                170,
                finalY + 30
            );

            // Save the PDF
            doc.save(`quotation_${quotationData.quotation_number || "export"}.pdf`);
            
        } catch (error) {
            console.error("Error generating PDF:", error);
            Swal.fire({
                title: "Error!",
                text: "Failed to generate PDF: " + error.message,
                icon: "error",
            });
        }
    };

    const handleSubmit = () => {
        if (!jobDate) {
            alert("Please select a date");
            return;
        }
        if (!customerName) {
            alert("Please enter customer name");
            return;
        }
        if (tableItems.length === 0) {
            alert("Please add items to the table");
            return;
        }

        tableItems.map(item => { item.itemId = item.jobTypeId });

        const customerData = {
            customerName: customerName,
            customerPhone: customerPhone
        };

        const submitData = {
            id: selectedQuotationForEdit ? selectedQuotationForEdit._id : null,
            jobDate,
            quoteDate,
            customerData,
            items: tableItems,
            discount,
            discountType,
            quotationNum,
            subtotal: calculateSubtotal(),
            comment: comment,
            userName,
            totalAfterDiscount: calculateTotalAfterDiscount(calculateSubtotal()),
        };
        createQuotation({
            data: submitData,
            setLoading: setLoading3,
            handleCancel,
            setIsQuotationCreated,
            showSuccess,
        });
    };

    const showSuccess = (msg) => {
        return Swal.fire({
            title: "Good job!",
            text: msg,
            icon: "success",
        });
    };

    const handleTableChange = (pagination) => {
        getAllQuotationMethod({
            setQuotationData,
            setLoading: setLoading4,
            params: { page: pagination.current, limit: pagination.pageSize },
            search,
            startDate: selectedRange[0].format("YYYY-MM-DD"),
            endDate: selectedRange[1].format("YYYY-MM-DD"),
        });
    };
    const handleQtyChange = (value, record, recordIndex) => {
        setTableItems(prevItems =>
            prevItems.map((item, index) =>
                index === recordIndex ? { ...item, qty: value, totalPrice: Number(record.price) * Number(value) } : item
            )
        );
    };
    const setItemDetails = (record, option, recordIndex) => {
        // console.log("Item", option)

        // Check if the item already exists in the table
        const itemExists = tableItems.some((item, index) => 
            index !== recordIndex && item.jobTypeId === option.jobType.value
        );

        if (itemExists) {
            Swal.fire({
                title: "Warning!",
                text: "This item is already added to the quotation",
                icon: "warning",
            });
            return;
        }

        setTableItems(prevItems =>
            prevItems.map((item, index) =>
                index === recordIndex
                    ? { 
                        ...item, 
                        label: option.jobType.label, 
                        qty: record.qty, 
                        jobTypeId: option.jobType.value, 
                        price: option.jobType.price, 
                        totalPrice: Number(option.jobType.price) * Number(record.qty) 
                      }
                    : item
            )
        );
        // console.log("Record", record)
    }
    const setData = (data) => {
        setQuotationNum(data.quotation_number);
        setJobDate(data.due_date.split("T")[0]);
        setQuoteDate(data.quote_date.split("T")[0]);
        
        if (data) {
            setCustomerName(data.customer || "");
            setCustomerPhone(data.phoneNumber || "");
        }
  
        setTableItems(
            data.items.map((item) => (
                {
                    itemId: item.itemDetails._id,
                    label: item.itemDetails.type,
                    qty: item.quantity,
                    price: item.itemDetails.price,
                    jobTypeId: item.itemDetails._id,
                    rowId: uuidv4()
                }))
        );
        setDiscount(data.discount.amount);
        setDiscountType(data.discount.type);
        setComment(data.comment)
    };


    const onChange = (dates) => {
        if (dates === null) {
            setSelectedRange([startOfCurrentMonth, endOfCurrentMonth]);
            return;
        }
        setSelectedRange(dates);
    };
    useEffect(() => {
        const initialCalls = async () => {
            
            const data2 = await getAllJobTypeMethod({
                search: "",
                setLoading: setLoading,
            });
            setJobTypeOptions(data2);
            
        };
        initialCalls();
    }, []);

    useEffect(() => {
        const handler = setTimeout(() => {
            getAllQuotationMethod({
                setQuotationData,
                setLoading: setLoading4,
                params: { page: quotationData.page, limit: quotationData.limit },
                search,
                startDate: selectedRange[0].format("YYYY-MM-DD"),
                endDate: selectedRange[1].format("YYYY-MM-DD"),
            });
        }, 600);

        return () => {
            clearTimeout(handler);
        };
    }, [search, selectedRange]);

    useEffect(() => {
        if (isQuotationCreated) {
            getAllQuotationMethod({
                setQuotationData,
                setLoading: setLoading4,
                params: { page: quotationData.page, limit: quotationData.limit },
                search,
                startDate: selectedRange[0].format("YYYY-MM-DD"),
                endDate: selectedRange[1].format("YYYY-MM-DD"),
            });
        }
    }, [isQuotationCreated]);

    useEffect(() => {
        if (tableItems.length === 0) {
            setDiscount(0);
            setDiscountType("fixed");
        }
    }, [tableItems]);

    useEffect(() => {
        if (selectedQuotation) {
            setData(selectedQuotation);
        }
        if (selectedQuotationForEdit) {
            setData(selectedQuotationForEdit);
        }
    }, [selectedQuotation, selectedQuotationForEdit]);

   
    const exportToExcel = () => {
        try {
            if (!quotationData.data || quotationData.data.length === 0) {
                Swal.fire({
                    title: "Warning!",
                    text: "No data to export",
                    icon: "warning",
                });
                return;
            }
            
            const exportData = quotationData.data.map(item => ({
                'Quote Date': item.quote_date ? new Date(item.quote_date).toLocaleDateString() : 'N/A',
                'Quotation Number': item.quotation_number || 'N/A',
                'Customer Name': item.customer || 'N/A',
                'Amount': item.total_after_discount ? 
                    `LKR ${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(item.total_after_discount)}` : 
                    'LKR 0.00',
                'Status': item.status || 'N/A'
            }));
            
            const worksheet = XLSX.utils.json_to_sheet(exportData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Quotations");
            
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            
            saveAs(data, `quotations_${new Date().toISOString().split('T')[0]}.xlsx`);
            
            Swal.fire({
                title: "Success!",
                text: "Excel file exported successfully",
                icon: "success",
            });
        } catch (error) {
            console.error("Error exporting to Excel:", error);
            Swal.fire({
                title: "Error!",
                text: "Failed to export to Excel: " || error.message,
                icon: "error",
            });
        }
    };

   
    const handlePrint = () => {
        try {
            if (!quotationData.data || quotationData.data.length === 0) {
                Swal.fire({
                    title: "Warning!",
                    text: "No data to print",
                    icon: "warning",
                });
                return;
            }
            
            const printWindow = window.open('', '_blank');
            
            const printContent = `
                <html>
                    <head>
                        <title>Quotation List</title>
                        <style>
                            body { font-family: Arial, sans-serif; margin: 20px; }
                            h1 { text-align: center; color: #333; }
                            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                            th, td { padding: 10px; text-align: left; border-bottom: 1px solid #ddd; }
                            th { background-color: #f2f2f2; font-weight: bold; }
                            .status-pending { color: orange; font-weight: bold; }
                            .status-approved { color: green; font-weight: bold; }
                            @media print {
                                button { display: none; }
                            }
                        </style>
                    </head>
                    <body>
                        <h1>Quotation List</h1>
                        <button onclick="window.print();" style="padding: 10px; background: #4CAF50; color: white; border: none; cursor: pointer; margin-bottom: 20px;">
                            Print Report
                        </button>
                        <table>
                            <thead>
                                <tr>
                                    <th>Quote Date</th>
                                    <th>Quotation Number</th>
                                    <th>Customer Name</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${quotationData.data.map(item => `
                                    <tr>
                                        <td>${item.quote_date ? new Date(item.quote_date).toLocaleDateString() : 'N/A'}</td>
                                        <td>${item.quotation_number || 'N/A'}</td>
                                        <td>${item.customer || 'N/A'}</td>
                                        <td>LKR ${item.total_after_discount ? 
                                            new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(item.total_after_discount) : 
                                            '0.00'}</td>
                                        <td class="${item.status === 'pending' ? 'status-pending' : 'status-approved'}">
                                            ${item.status === 'pending' ? 'Pending' : 'Approved'}
                                        </td>
                                    </tr>
                                `).join('')}
                            </tbody>
                        </table>
                    </body>
                </html>
            `;
            
            printWindow.document.open();
            printWindow.document.write(printContent);
            printWindow.document.close();
            
            printWindow.focus();
        } catch (error) {
            console.error("Error printing :", error);
            Swal.fire({
                title: "Error!",
                text: "Failed to print: " + error.message,
                icon: "error",
            });
        }
    };

    // Update the PDF export function to handle multiple quotations
    const downloadAllQuotationsPDF = async () => {
        try {
            if (!quotationData.data || quotationData.data.length === 0) {
                Swal.fire({
                    title: "Warning!",
                    text: "No quotations available to export",
                    icon: "warning",
                });
                return;
            }

            const doc = new jsPDF("p", "mm", "a4");
            const pageWidth = doc.internal.pageSize.getWidth();
            
            // Add header and company info on the first page
            try {
                const logoUrl = "assets/img/logo/logo.jpeg";
                const logoBase64 = await getBase64FromUrl(logoUrl);
                doc.addImage(logoBase64, "PNG", 14, 10, 30, 30);
            } catch (error) {
                console.error("Error loading logo:", error);
                // Continue without logo
            }
            
            doc.setFontSize(18);
            doc.text("The Suit - All Quotations", pageWidth/2, 15, { align: "center" });
            doc.setFontSize(10);
            doc.text("335, Colombo Road, Negombo, Gampaha 11500, Sri Lanka", pageWidth/2, 22, { align: "center" });
            doc.text("Phone: 0314355515, Mobile: 0774055515", pageWidth/2, 28, { align: "center" });
            
            doc.setDrawColor(182, 182, 181);
            doc.line(10, 35, pageWidth-10, 35);
            
            // Create table data for all quotations
            const tableData = quotationData.data.map((item, index) => [
                index + 1,
                item.quotation_number || "N/A",
                item.quote_date ? new Date(item.quote_date).toLocaleDateString() : "N/A",
                item.customer || "N/A",
                "Rs " + formatNumber(item.total_after_discount || 0),
                item.status === "pending" ? "Pending" : "Approved"
            ]);
            
            // Add table to PDF
            doc.autoTable({
                startY: 40,
                head: [["#", "Quotation #", "Date", "Customer", "Amount", "Status"]],
                body: tableData,
                theme: "grid",
                styles: { fontSize: 8, cellPadding: 2 },
                headStyles: { fillColor: [74, 74, 73], textColor: [255, 255, 255] },
                alternateRowStyles: { fillColor: [240, 240, 240] },
                margin: { top: 40 }
            });
            
            // Add footer
            const finalY = doc.previousAutoTable.finalY + 10;
            doc.setFontSize(8);
            doc.text(`Total Quotations: ${quotationData.data.length}`, 14, finalY);
            doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, finalY + 5);
            
            // Save the PDF
            doc.save(`all_quotations_${new Date().toISOString().split('T')[0]}.pdf`);
            
            Swal.fire({
                title: "Success!",
                text: "All quotations exported to PDF successfully",
                icon: "success",
            });
        } catch (error) {
            console.error("Error generating PDF:", error);
            Swal.fire({
                title: "Error!",
                text: "Failed to generate PDF: " + error.message,
                icon: "error",
            });
        }
    };

    

    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Quotation List</h4>
                                <h6>Manage Your Quotations</h6>
                            </div>
                        </div>
                        <div className="page-btn">
                            
                                <Link
                                    className="btn btn-added"
                                    onClick={() => {
                                        showModal();
                                        getRateQuotationNum();
                                    }}
                                >
                                    <PlusCircle className="me-2" />
                                    Add New Quotation
                                </Link>
                            

                        </div>
                    </div>
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-top">
                                <div className="search-set">
                                    <div className="search-input">
                                        <input
                                            type="search"
                                            className="form-control"
                                            placeholder="Search"
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                        <Link className="btn btn-searchset">
                                            <i data-feather="search" className="feather-search" />
                                        </Link>
                                    </div>
                                    <RangePicker
                                        onChange={onChange}
                                        value={selectedRange}
                                        format="YYYY-MM-DD"
                                    />
                                    <div className="wordset">
                                        <ul>
                                            <li>
                                                <a
                                                    
                                                    onClick={() => downloadAllQuotationsPDF()}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="pdf"
                                                >
                                                    <img src="assets/img/icons/pdf.svg" alt="pdf" />
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    
                                                    onClick={exportToExcel}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="excel"
                                                >
                                                    <img src="assets/img/icons/excel.svg" alt="excel" />
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    
                                                    onClick={handlePrint}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="print"
                                                >
                                                    <img src="assets/img/icons/printer.svg" alt="print" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                            <div className="table-responsive">
                                <Table
                                    columns={quotationColumns}
                                    dataSource={quotationData.data}
                                    rowKey="_id"
                                    pagination={{
                                        current: quotationData.page,
                                        pageSize: quotationData.limit,
                                        total: quotationData.total,
                                    }}
                                    loading={loading4}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal for view,edit and create invoice */}
            <Drawer
                onClose={handleCancel} open={isModalOpen} width={1000}  mask={true}   maskClosable={false}
            >

                <div className="modal-dialog add-centered">
                    <div className="modal-content">
                        <div className="page-wrapper p-0 m-0">
                            <div className="content p-0">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>
                                            {" "}
                                            {selectedQuotation
                                                ? "View"
                                                : selectedQuotationForEdit
                                                    ? "Edit"
                                                    : "Add"}{" "}
                                            Quotation
                                        </h4>
                                        <label>Fill all fields to create an Quotation</label>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-body">
                                        <div
                                            className="row"
                                        >
                                            <div className="col-lg-12 col-sm-12 col-12">
                                                
                                                    <div className="row">
                                                        <div className="col-lg-6 col-sm-6 col-12">
                                                            <div className="input-blocks">
                                                                <label className="form-label">Customer Name</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter customer name"
                                                                    value={customerName}
                                                                    onChange={(e) => setCustomerName(e.target.value)}
                                                                    disabled={selectedQuotation}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-sm-6 col-12">
                                                            <div className="input-blocks">
                                                                <label className="form-label">Customer Phone</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter phone number"
                                                                    value={customerPhone}
                                                                    onChange={(e) => setCustomerPhone(e.target.value)}
                                                                    disabled={selectedQuotation}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                
                                            </div>
                                            <div className="col-lg-12 col-sm-12 col-12">
                                                <div className="input-blocks">
                                                    <label>Quotation No</label>
                                                    <input
                                                        type="text"
                                                        disabled
                                                        className="form-control"
                                                        value={quotationNum}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-sm-6 col-12">
                                                <div className="input-blocks">
                                                    <label>Quote Date</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={quoteDate}
                                                        onChange={(e) => setQuoteDate(e.target.value)}
                                                        disabled={selectedQuotation}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-sm-6 col-12">
                                                <div className="input-blocks">
                                                    <label>Due Date</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={jobDate}
                                                        onChange={(e) => setJobDate(e.target.value)}
                                                        disabled={selectedQuotation}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Add this section to show edit information */}
                                        {(selectedQuotation || selectedQuotationForEdit) && 
                                            (selectedQuotation?.lastEditedAt || selectedQuotationForEdit?.lastEditedAt) && (
                                            <div className="col-lg-12 col-sm-12 col-12 mt-3">
                                                <div className="alert alert-info" role="alert">
                                                    <div className="d-flex justify-content-between">
                                                        <div>
                                                            <strong>Last Edited:</strong> {
                                                                selectedQuotation?.lastEditedAt 
                                                                ? new Date(selectedQuotation.lastEditedAt).toLocaleString() 
                                                                : selectedQuotationForEdit?.lastEditedAt 
                                                                ? new Date(selectedQuotationForEdit.lastEditedAt).toLocaleString()
                                                                : "N/A"
                                                            }
                                                        </div>
                                                        <div>
                                                            <strong>Edited By:</strong> {
                                                                selectedQuotation?.lastEditedBy || 
                                                                selectedQuotationForEdit?.lastEditedBy || 
                                                                ""
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className="table-responsive">
                                            <Table
                                                columns={columns}
                                                dataSource={tableItems}
                                                rowKey="rowId"
                                            />

                                            <Button
                                                onClick={handleAdd}
                                                type="primary"
                                                style={{
                                                    marginBottom: 16,
                                                }}
                                            >
                                                Add a row
                                            </Button>
                                        </div>
                                        <div style={{ marginTop: "20px" }}>
                                            <div className="row">
                                                <div className="col-lg-6 col-sm-6 col-12">
                                                    <div className="input-blocks">
                                                        <label>Discount Type</label>
                                                        <select
                                                            value={discountType}
                                                            onChange={(e) => {
                                                                if (
                                                                    e.target.value == "percentage" &&
                                                                    discount > 100
                                                                ) {
                                                                    alert("Discount cannot be greater than 100%");
                                                                    return;
                                                                }
                                                                setDiscountType(e.target.value);
                                                            }}
                                                            className="form-control"
                                                            disabled={
                                                                tableItems.length === 0 || selectedQuotation
                                                            }
                                                        >
                                                            <option value={"fixed"}>Fixed</option>
                                                            <option value={"percentage"}>Percentage</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-sm-6 col-12">
                                                    <div className="input-blocks">
                                                        <label>Discount</label>
                                                        <Input
                                                            type="number"
                                                            className="form-control"
                                                            value={discount}
                                                            disabled={
                                                                tableItems.length === 0 || selectedQuotation
                                                            }
                                                            onChange={(e) => {
                                                                if (
                                                                    discountType === "percentage" &&
                                                                    e.target.value > 100
                                                                ) {
                                                                    alert("Discount cannot be greater than 100%");
                                                                    return;
                                                                } else if (
                                                                    discountType === "percentage" &&
                                                                    e.target.value < 0
                                                                ) {
                                                                    alert("Discount cannot be negative");
                                                                    return;
                                                                } else if (
                                                                    discountType === "fixed" &&
                                                                    e.target.value < 0
                                                                ) {
                                                                    alert("Discount cannot be negative");
                                                                    return;
                                                                } else if (
                                                                    discountType === "fixed" &&
                                                                    e.target.value > calculateSubtotal()
                                                                ) {
                                                                    alert(
                                                                        "Discount cannot be greater than Subtotal"
                                                                    );
                                                                    return;
                                                                } else if (e.target.value == "") {
                                                                    setDiscount(0);
                                                                } else {
                                                                    setDiscount(e.target.value);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-lg-6 col-sm-6 col-12">
                                                    <div className="input-blocks">
                                                        <label>Subtotal</label>
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            value={calculateSubtotal()}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-sm-6 col-12">
                                                    <div className="input-blocks">
                                                        <label>Total after Discount</label>
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            value={calculateTotalAfterDiscount(
                                                                calculateSubtotal()
                                                            )}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 col-sm-6 col-12">
                                                    <div className="input-blocks">
                                                        <label>Comment</label>
                                                        <textarea

                                                            rows={4}
                                                            placeholder="Type your message"
                                                            className="form-control"
                                                            defaultValue={""}
                                                            onChange={(e) => setComment(e.target.value)}

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <div>
                                        {!selectedQuotation && (
                                            <>
                                                <button
                                                    type="button"
                                                    className="btn btn-cancel me-2"
                                                    onClick={() => {
                                                        handleReset();
                                                    }}
                                                >
                                                    Reset
                                                </button>
                                                <button
                                                    className="btn btn-submit"
                                                    onClick={() => {
                                                        handleSubmit();
                                                    }}
                                                >
                                                    {loading3 ? <Spin size="small" /> : "Save"}
                                                </button>
                                            </>
                                        )}
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-cancel"
                                        onClick={() => {
                                            handleCancel();
                                            setSelectedQuotation(null);
                                            setSelectedQuotationForEdit(null);
                                        }}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
            {/* Modal for payment */}
            
        </div>
    );
};

export default QuotationList;
